// apps/website/src/index.tsx
//
// Marketing site entry point. The website is intentionally small: it renders
// the public pages (/, /terms, /privacy) and hands off authentication to the
// webapp via an absolute URL (REACT_APP_WEBAPP_URL), so no router-level auth
// guard is needed here.
import React from "react";
import ReactDOM from "react-dom/client";
import "./styles/global.css";
import "./styles/theme/variables.css";
import "./styles/theme/ember-shell.css";
import App from "./App";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
